function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.48 6.77H9.86a5.32 5.32 0 0 0-4.52 8.11l4.64 7.82a3.82 3.82 0 0 0 6.73.02l9.18-15.2a.5.5 0 0 0-.41-.75ZM12.9 21.05l-4.76-7.97a2 2 0 0 1 1.72-2.98h9.85a.5.5 0 0 1 .42.74L13.8 21.06a.5.5 0 0 1-.9 0Z",
  fill: "currentColor"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAzMCIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI1LjQ4IDYuNzdIOS44NmE1LjMyIDUuMzIgMCAwIDAtNC41MiA4LjExbDQuNjQgNy44MmEzLjgyIDMuODIgMCAwIDAgNi43My4wMmw5LjE4LTE1LjJhLjUuNSAwIDAgMC0uNDEtLjc1Wk0xMi45IDIxLjA1bC00Ljc2LTcuOTdhMiAyIDAgMCAxIDEuNzItMi45OGg5Ljg1YS41LjUgMCAwIDEgLjQyLjc0TDEzLjggMjEuMDZhLjUuNSAwIDAgMS0uOSAwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";
export { ForwardRef as ReactComponent };